import { useMachine } from '@xstate/react'
import { CreateProps } from 'api/create'
import {
  requestMachine,
  RequestMachineContext,
  RequestMachineEventData,
  RequestMachineStates,
} from 'machines/requestMachine'
import { useUsersActions } from 'providers'
import { useCallback } from 'react'
import { State } from 'xstate'

/** Reads the user from the DB, returns the full user or undefined as well as the current read state */
export const useCreate = (): [
  State<RequestMachineContext, RequestMachineEventData, RequestMachineStates>,
  (formData: CreateProps['formData']) => void
] => {
  const [state, send] = useMachine(requestMachine)
  const { create: createUser } = useUsersActions()

  const create = useCallback(
    async (formData: CreateProps['formData']) => {
      const promise = createUser({ formData })
      send('SET_PROMISE', { data: promise })
    },
    [send, createUser]
  )

  return [state, create]
}
